import { NgModule } from '@angular/core';
import { CART_QUICK_ORDER_FEATURE, QuickOrderRootModule } from '@spartacus/cart/quick-order/root';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [QuickOrderRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_QUICK_ORDER_FEATURE]: {
          module: () => import('@spartacus/cart/quick-order').then((m) => m.QuickOrderModule),
        },
      },
    }),
  ],
})
export class CartQuickOrderFeatureModule {}
